import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './services/vuetify.service'
import './bootstrap/plugins.bootstrap'
import './bootstrap/components.bootstrap'
import './bootstrap/filters.bootstrap'
import './bootstrap/froala.bootstrap'
import './vee-validate'
import './scss/main.scss'

Vue.config.productionTip = false
Vue.prototype.$url = process.env.VUE_APP_API_URL

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
